import { serviceConfig } from '@/config/request/swaggerServiceConfig';
import { Api as Smc } from './smc';
import { Api as Customer } from './customer';

export const Api = { Smc, Customer };

const warpperServiceConfig = (serviceConfig: any, ctx: { name: string }) => {
    const newConfig = { ...serviceConfig };
    if (newConfig.baseURL) {
        newConfig.baseURL = newConfig.baseURL + '/' + ctx.name;
    }
    return newConfig;
};

const smc = new Smc(warpperServiceConfig(serviceConfig, { name: 'smc' }));
const customer = new Customer(
    warpperServiceConfig(serviceConfig, { name: 'customer' })
);

export const apiInstanceList = [
    { key: 'smc', instance: smc },
    { key: 'customer', instance: customer }
];

export const api = { smc, customer };
